/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Detail_Explore_LandscapeInputs */

const en_directory_detail_explore_landscape = /** @type {(inputs: Directory_Detail_Explore_LandscapeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continue exploring`)
};

const zh_directory_detail_explore_landscape = /** @type {(inputs: Directory_Detail_Explore_LandscapeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`继续探索`)
};

/**
* | output |
* | --- |
* | "Continue exploring" |
*
* @param {Directory_Detail_Explore_LandscapeInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_detail_explore_landscape = /** @type {((inputs?: Directory_Detail_Explore_LandscapeInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Detail_Explore_LandscapeInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_detail_explore_landscape(inputs)
	return zh_directory_detail_explore_landscape(inputs)
});
export { directory_detail_explore_landscape as "directory.detail.explore_landscape" }